import { Button } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { LoadingButton } from '@mui/lab'
import { useSelector } from 'react-redux'

function BookingButtons(props) {
    const disabledConditions = props.stepperContinueConditions(props.steps)
    const [width, setWidth]= useState(window.innerWidth)
    useEffect(() => {
        const handleResize = () => {
          setWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        return () => {
          window.removeEventListener('resize', handleResize);
        };
      }, [])
      const patientFoundLoading = useSelector((state) => state?.appointments?.handleLoaderContinue)
    return (
        <div className="booking_buttons">
            {props.steps === 0
                ? ' '
                : props.steps < 4 && (
                      <Button
                          variant="contained"
                          color="success"
                          onClick={props.handlePreviousStep}
                          disabled={props?.isLoading}
                          style={{ background: '#5571C6' }}>
                          Back
                      </Button>
                  )}
            <>
                {patientFoundLoading && (
                    <LoadingButton
                        variant="contained"
                        disabled={disabledConditions}
                        loading={patientFoundLoading}
                        onClick={props.handleNextStep}
                        sx={{
                            '& .MuiCircularProgress-root': {
                                color: '#fff',
                            },
                            minHeight: '33px',
                        }}
                        style={{
                            background: '#15a452',
                            opacity: disabledConditions ? 0.5 : 1,
                            color: disabledConditions ? 'rgba(255, 255, 255, 0.70)' : '#fff',
                            width: props.steps === 6 ? '100%' : '',
                            fontWeight: '600',
                        }}>
                        {' '}
                    </LoadingButton>
                )}
                {props.steps !== 6 && !patientFoundLoading && (
                    <LoadingButton
                        variant="contained"
                        disabled={disabledConditions || props?.isLoading}
                        loading={patientFoundLoading}
                        onClick={props.handleNextStep}
                        sx={{
                            '& .MuiCircularProgress-root': {
                                color: '#fff',
                            },
                            minHeight: '33px',
                        }}
                        style={{
                            background: '#15a452',
                            opacity: disabledConditions ? 0.5 : 1,
                            color: disabledConditions ? 'rgba(255, 255, 255, 0.70)' : '#fff',
                            width: props.steps === 6 ? '100%' : '',
                            fontWeight: '600',
                        }}>
                        {props.steps !== 4 ? 'Continue' : 'Complete'}
                    </LoadingButton>
                )}
            </>
        </div>
    )
}

export default BookingButtons
